export default function PaymentSuccess(){
    return(
        <div className="payment-success-container">
            Your payment was successful
        </div>
    )
}